import React from 'react'
import TextField from '@mui/material/TextField';
// import TextField from "@material-ui/core/TextField";
import { useTheme, withStyles } from '@mui/styles';

export default function Input(props) {

    const theme = useTheme();

    const DarkerDisabledTextField = withStyles({
        root: {
            "& .MuiOutlinedInput-input.Mui-disabled": {
                color: theme.palette.grey[900],
                "-webkit-text-fill-color": theme.palette.grey[900]
            }
        }
    })(TextField);

    const { fontDisableColor = false, name, label, value, error = null, helperText = error, onBlur, onChange, required, ...other } = props;

    if (!fontDisableColor) {
        return (
            <TextField
                variant="outlined"
                label={label}
                name={name}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
                required={required}
                {...other}
                {...(error && { error: true, helperText: helperText })}
                helperText={error ? helperText : ''}
            />
        )
    } else {
        return (
            <DarkerDisabledTextField
                variant="outlined"
                label={label}
                name={name}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
                required={required}
                {...other}
                {...(error && { error: true, helperText: helperText })}
                helperText={error ? helperText : ''}
            />
        )
    }
}
